import React from "react";
import Navbar from "./components/navbar";
import Hero from "./components/hero";
import Planos from "./components/planos";
import Company from "./components/company";
import Stats from "./components/Stats";
import Footer from "./components/Footer"
import Contato from "./components/Contato"
// import TagManager from 'react-gtm-module'

// const tagManagerArgs = {
//   gtmId: '<ID do GTM tipo (GTM-XXXXXXX)>'
// }
// TagManager.initialize(tagManagerArgs)

// window.dataLayer.push({
//   event: 'pageview'
// })

function App() {
  document.title = "eLav Seminário"
  localStorage.theme = 'dark'
  return (
    <div>
      <div className="divide-y divide-black">
        <Navbar />
        <Hero />
      </div>
      
      <Planos />
      <Company />
      <Stats />
      <div className="divide-y divide-white-80">
        <Contato />
        <Footer />
      </div>

      </div>
  );
}

export default App;